export const Label = {
  //TODO
};
